/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Boards/Content/BoardItem/IconAndTitle/AssignedToMe/Loading"
  
}) {
  return null
}